import * as graphql from '@treams/treams-network';
import { Switch } from '@treams/treams-ui';

export default function ConfigurationFieldBoolean(props: {
	// Explicitly added { boolean } to this type. Apollo does not generate this correctly from the fragment.
	field: graphql.ConnectorConfigFieldBoolean & { boolean: boolean };
	autoFocus?: boolean;
	change?: Partial<graphql.UpdateConnectorConfigFieldInput>;
	onChange: (input: Partial<graphql.UpdateConnectorConfigFieldInput>) => void;
}) {
	return (
		<Switch
			on={props.change?.boolean ?? props.field.boolean ?? false}
			onChange={(value) => props.onChange({ boolean: value })}
		/>
	);
}
